import { render, staticRenderFns } from "./agentHome.vue?vue&type=template&id=5b4015b0&scoped=true"
import script from "./agentHome.vue?vue&type=script&lang=js"
export * from "./agentHome.vue?vue&type=script&lang=js"
import style0 from "./agentHome.vue?vue&type=style&index=0&id=5b4015b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4015b0",
  null
  
)

export default component.exports